import { c as _c } from "react/compiler-runtime";
import { useSwitch } from "@website/ui/switch/switch.hook";
import styles from "@website/ui/switch/switch.module.scss";
import { SwitchPropertiesType } from "@website/ui/switch/switch.types";
import { FC, Fragment } from "react";
export const Switch: FC<SwitchPropertiesType> = properties => {
  const $ = _c(19);
  const {
    inputProps
  } = useSwitch(properties);
  const {
    className,
    color,
    disabled,
    label,
    error,
    helperText
  } = properties;
  const t0 = `${styles.container} ${disabled ? styles.disabled : ""} ${styles[color || "primary"]} ${className ?? ""} ${error ? styles.error : ""}`;
  let t1;
  if ($[0] !== inputProps) {
    t1 = <input {...inputProps} className={styles.input} />;
    $[0] = inputProps;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className={styles.slider} />;
    t3 = <span className={styles.knob} />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1) {
    t4 = <span className={styles["input-wrapper"]}>{t1}{t2}{t3}</span>;
    $[4] = t1;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = !label;
  let t6;
  if ($[6] !== label || $[7] !== t5) {
    t6 = <span className={styles.label} hidden={t5}>{label}</span>;
    $[6] = label;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== error || $[10] !== t0 || $[11] !== t4 || $[12] !== t6) {
    t7 = <span><label className={t0} data-error={error} data-testid="switch-wrapper">{t4}{t6}</label></span>;
    $[9] = error;
    $[10] = t0;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== helperText) {
    t8 = helperText ? <span className={styles["helper-text"]}>{helperText}</span> : null;
    $[14] = helperText;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t7 || $[17] !== t8) {
    t9 = <Fragment>{t7}{t8}</Fragment>;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
};